import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-vb-minimum-age-person-card',
  templateUrl: './vb-minimum-age-person-card.component.html',
  styleUrls: ['./vb-minimum-age-person-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbMinimumAgePersonCardComponent implements OnChanges {
  @Input() name!: string;
  @Input() dateOfBirth!: string;
  @Input() label!: string;
  @Input() showRadioButton = false;
  @Input() radioControlId: string | null = null;
  @Input() radioName: string | null = null;
  @Input() radioValue: string | null = null;
  @Input() radioFormControl: FormControl<string | null> | null = null;
  @Output() selected = new EventEmitter<void>();

  protected formattedDateOfBirth: string | null = null;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.dateOfBirth) {
      this.formattedDateOfBirth = this.dateOfBirth ? moment.utc(this.dateOfBirth).format('MMMM D, YYYY') : null;
    }
  }
}
